export const DEFAULT_BUTTON = 'default';
export const GOOGLE_BUTTON = 'google-sign-in';
export const INVERTED_BUTTON = 'inverted';